module.exports = __webpack_public_path__ + "images/line_friend_lp/campaign-date_b5c1dc1a35073df48ac726a246ff44d4.png";